export const actionTypes = {
  TAG_LIST_REQUEST: 'TAG_LIST_REQUEST',
  TAG_LIST_SUCCESS: 'TAG_LIST_SUCCESS',
  TAG_LIST_FAILURE: 'TAG_LIST_FAILURE',
};
